<div id="countdown">
  <div id="countdown-close" *ngIf="close" (click)="closeCounter()">
    <img src="../../../../assets/icons/close.svg" class="child hidden" alt="close" title="close" class="Group-74 close-btn-position" />
  </div>
  <div id="countdown-number" *ngIf="!close">{{ seconds }}</div>
  <svg id="svg-circle" *ngIf="!closeOnly">
    <circle r="18" cx="20" cy="20" style="animation: countdown {{ countdown }}s linear infinite forwards"></circle>
  </svg>
</div>
